module.exports = __webpack_public_path__ + "static/media/yes_no_btn01.c84fe740.png";